import {Injectable} from '@angular/core';
import {Events} from 'ionic-angular';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Providers


export interface IEmployee {
    id: number;
    firstname: string;
    lastname: string;
}

@Injectable()
export class rsEmployeeSvc {

    constructor( private http: Http, private events: Events ) 
    {
        
    }
    getEmployees( filter: string = "visible" ) : Observable<IEmployee[]> {
        // Return our observable
        return Observable.create( observer => {
            // This method gets run when an object subscribes
            this.http.get( 'http://dfr.hydrocon.com/api/v1/employees/filters/' + filter, {
                withCredentials: true
            })
            .map( res => {
                return res.json().response.employees;
            })
            .subscribe( result => {
                // operation successful
                observer.next(result);
            }, err=> {
                // error encountered
                observer.error(err);
            }, () => {
                // operation complete
                observer.complete();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/employee.service.ts